import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { UserPlus, UserCheck } from 'lucide-react';
import { followService } from '../services/followService';
import { useAuth } from '../context/AuthContext';

const StyledButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 24px;
  border: 2px solid var(--primary-gold, #e0c16f);
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 600;
  font-family: var(--font-body);
  cursor: pointer;
  transition: all 0.3s ease;
  
  /* Ako je zapraćen - Zlatna pozadina, crn tekst. Ako nije - providno sa zlatnim okvirom */
  background: ${props => props.isFollowing ? 'linear-gradient(95.36deg, #e0c16f 5.18%, #bd851b 93.21%)' : 'transparent'};
  color: ${props => props.isFollowing ? '#000000' : '#ffffff'};
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 15px rgba(224, 193, 111, 0.3);
    background: linear-gradient(95.36deg, #e0c16f 5.18%, #bd851b 93.21%);
    color: #000000;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    transform: none;
  }
`;

const FollowButton = ({ creatorId, onFollowChange }) => {
  const { user } = useAuth();
  const [isFollowing, setIsFollowing] = useState(false);
  const [loading, setLoading] = useState(true);

  // Proveravamo da li već pratiš ovog kreatora čim se učita stranica
  useEffect(() => {
    if (user && creatorId) {
      checkFollowStatus();
    } else {
      setLoading(false);
    }
  }, [user, creatorId]);

  const checkFollowStatus = async () => {
    try {
      const data = await followService.getFollowStatus(creatorId);
      setIsFollowing(data.isFollowing);
    } catch (error) {
      console.error('Failed to check follow status:', error);
    } finally {
      // OBAVEZNO OSLOBAĐA DUGME ČAK I AKO JE BILA GREŠKA
      setLoading(false); 
    }
  };

  const handleFollowToggle = async () => {
    if (!user) {
      alert('You must be logged in to follow creators.');
      return;
    }
    
    if (!creatorId) {
      console.error("Greška: creatorId fali!");
      return;
    }

    try {
      setLoading(true); // Zaključava dugme dok backend ne završi
      console.log(`Šaljem zahtev za kreatora ${creatorId}... Trenutno stanje:`, isFollowing);
      
      if (isFollowing) {
        await followService.unfollowCreator(creatorId);
        setIsFollowing(false);
        if (onFollowChange) onFollowChange(false);
        console.log("Uspešno otpraćen!");
      } else {
        await followService.followCreator(creatorId);
        setIsFollowing(true);
        if (onFollowChange) onFollowChange(true);
        console.log("Uspešno zapraćen!");
      }
    } catch (error) {
      console.error('Error toggling follow:', error);
      alert('Došlo je do greške. Pogledaj konzolu.');
    } finally {
      setLoading(false); // Ponovo oslobađa dugme
    }
  };

  return (
    <StyledButton 
      isFollowing={isFollowing} 
      onClick={handleFollowToggle}
      disabled={loading}
    >
      {loading ? (
        'Loading...'
      ) : isFollowing ? (
        <><UserCheck size={18} /> Following</>
      ) : (
        <><UserPlus size={18} /> Follow</>
      )}
    </StyledButton>
  );
};

export default FollowButton;